<template>
  <div v-if="showHeader" id="topnav" class="topnav">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <div class="logo">
      <router-link to="/" href="#home"><img @click="close_nav" class="logo" v-bind:class="getClass_logo()" src="../assets/logo.png"></router-link>
    </div>
    <div class="nav" id="nav">
      <router-link class="tab" to="/immatriculation"><a @click="close_nav" class="tab">Immatriculation</a></router-link>
      <router-link class="tab" to="/conduite"><a @click="close_nav" class="tab">Conduite</a></router-link>
      <router-link class="tab" to="/etat_civil"><a @click="close_nav" class="tab">Etat Civil</a></router-link>
<!--       <router-link class="tab" to="/professionnels"><a @click="close_nav" class="tab">Professionnels</a></router-link> -->
      <router-link class="tab" to="/contact"><a @click="close_nav" class="tab">Contact</a></router-link>
      <router-link class="tab go" to="/go"><a @click="close_nav" class="tab">C'est parti !</a></router-link>
    </div>
    <div class="resp_nav">
      <span class="resp2" id="nav2">{{this.$route.name == this.$route.meta.parent_name ? "" : this.$route.meta.parent_name}}</span>
      <i @click="resp_nav" class="fa fa-bars"></i>
    </div>
    <div v-if="subnav()" class="sub_nav fade-in fade-out">
      <div class="sub_nav_1">
      </div>
      <div class="sub_nav_2">
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/carte_grise"><a @click="close_nav" class="sub_tab">Carte Grise</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/adresse"><a @click="close_nav" class="sub_tab">Changement d'adresse</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/cession"><a @click="close_nav" class="sub_tab">Déclaration de cession</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/duplicata"><a @click="close_nav" class="sub_tab">Duplicata</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/vehicule_etranger"><a @click="close_nav" class="sub_tab">Véhicule étranger</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/succession"><a @click="close_nav" class="sub_tab">Succession</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/matrimonial"><a @click="close_nav" class="sub_tab">Changement matrimonial</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/collection"><a @click="close_nav" class="sub_tab">Véhicule de collection</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Immatriculation')" class="sub_tab" to="/immatriculation/autres_immat"><a @click="close_nav" class="sub_tab">Autres</a></router-link>

        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Conduite')" class="sub_tab" to="/conduite/neph"><a @click="close_nav" class="sub_tab">N° NEPH</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Conduite')" class="sub_tab" to="/conduite/premiere_demande"><a @click="close_nav" class="sub_tab">Première demande</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Conduite')" class="sub_tab" to="/conduite/duplicata"><a @click="close_nav" class="sub_tab">Duplicata</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Conduite')" class="sub_tab" to="/conduite/renouvellement"><a @click="close_nav" class="sub_tab">Renouvellement</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Conduite')" class="sub_tab" to="/conduite/suspensions"><a @click="close_nav" class="sub_tab">Suspensions/annulations</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Conduite')" class="sub_tab" to="/conduite/international"><a @click="close_nav" class="sub_tab">Permis international</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Conduite')" class="sub_tab" to="/conduite/codengo"><a @click="close_nav" class="sub_tab">Coden'go</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Conduite')" class="sub_tab" to="/conduite/stages"><a @click="close_nav" class="sub_tab">Stages de récupération de points</a></router-link>

        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Etat_civil')" class="sub_tab" to="/etat_civil/carte_identite_passeport"><a @click="close_nav" class="sub_tab">Carte d'identité et passeport</a></router-link>
        <router-link v-if="this.$route.matched.some(({ name }) => name === 'Etat_civil')" class="sub_tab" to="/etat_civil/photomaton"><a @click="close_nav" class="sub_tab">Photomaton</a></router-link>
      </div>
    </div>
  </div>

</template>

<script>
export default {
	name: 'Header',
	data () {
		return {}
	},
	created () {
    this.parent_name=this.$route.meta.parent_name
	},
	/*
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }, */
  computed: {
    showHeader () {
      return !(
        this.$route.path === '/go/immatriculation' &&
        this.$route.query.pay === 'ppweb'
      )
    }
  },
	methods: {
		subnav () {
			if ((this.$route.path == '/') || (this.$route.path == '/contact') || (this.$route.path == '/go') || (this.$route.path == '/conformite') || (this.$route.path == '/go/immatriculation') || (this.$route.path == '/go/suivi') || (this.$route.name == 'PageNotFound')) {
				return false
			} else {
				return true
			}
			// console.log(this.path)
		},
		resp_nav (event) {
			var x = document.getElementById('nav')
      var x2 = document.getElementById('nav2')
			if (x.className === 'nav') {
				x.className = 'resp'
        x2.className = 'nav'
			} else {
				x.className = 'nav'
        x2.className = 'resp2'
			}
		},
		close_nav (event) {
			var x = document.getElementById('nav')
      var x2 = document.getElementById('nav2')
			// console.log(window.innerWidth)
			if ((x.className === 'resp') && (window.innerWidth <= 800)) {
				x.className = 'nav'
        x2.className = 'resp2'
			} else if ((x.className === 'resp') && (window.innerWidth > 800)){
        x.className = 'nav'
      } /*else {
				x.className = 'resp'
			}*/
		},
		getClass_logo () {
			if (this.subnav()) {
				return 'withsub'
			} else {
				return 'withoutsub'
			}
		}
		/*
    handleScroll(event){
    // Get the topnav
    const topnav = document.getElementById("topnav");

    // Get the offset position of the topnav
    const sticky = topnav.offsetTop;//+topnav.offsetHeight*0.5;
    console.log(window.pageYOffset+" - "+sticky);
      if (window.pageYOffset > sticky) {
        topnav.classList.add("sticky")
      } else {
        topnav.classList.remove("sticky");
      }
    } */
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.topnav{
  display:flex;
  flex-flow: row wrap;
  min-height:110px;
  max-height:110px;
  height:110px;
  background-color:#fbfbfb;
  //border-bottom: solid 1px #3c3c3c;
  box-shadow: 0px 2px 2px #1a1a1a;
}

.logo{
  display:flex;
  justify-content:center;
  flex:1;
  align-items:center;
  background-color:#fbfbfb;
  padding:5px 5px 5px 5px;
}

.withsub{
  width:150px;
}
.withoutsub{
  width:200px;
}

.nav{
  display:flex;
  flex-flow: row ;
  justify-content:center;
  flex:4;
  align-items:stretch;
  width: 100M;
}

.resp{
  display:flex;
  flex-flow: row wrap;
  justify-content:space-around;
  flex:4;
  align-items:center;
}

.resp_nav{
  display:none;
  flex:1;
  justify-content:flex-end;
  align-items:center;
  padding:10px 30px 10px 20px;
  background-color:#fbfbfb;
}
.resp_nav i{
  cursor:pointer;
}

.nav > .tab{
  display: flex;
  align-items:center;
  justify-content:center;

  text-decoration:none;
  color:black;
  padding:10px;
  text-align: center;
  width: 20%;
}

.tab.go{
  /*background: rgba(204,11,66,1);*/
  background-color: #22407a;
  color: white;
  font-weight:450;
}
.tab.go:hover, .tab.go > a:hover{
  color:#E9ECF3;
}

.tab:hover{
  /*color:#22407a;*/
  color: #22417B
}

.sub_nav{
  display:flex;
  width:100%;
  background-color:#22407a;
  align-items:center;
  border-top:solid 1px #fbfbfb;
}

.sub_nav_1{
  flex:0 10 0;
}

.sub_nav_2{
  display:flex;
  flex:4;
  flex-flow:row;
  justify-content:space-around;
  align-items:center;
}

.sub_tab{
  color:#ebeced;
  text-decoration:none;
  font-size:0.85em;
  padding:0px 5px 0px 5px;
  text-align:center;
}

.sub_tab:hover{
  color:#ffffff;
}

@media all and (max-width: 900px) {
  .logo{width:120px;}
  .topnav{font-size:0.8em;}
  .nav{display:none;}
  .resp_nav{display:flex;}
  .sub_nav_1{flex:0;}
  .sub_nav_2{flex-flow:row wrap}
  .sub_tab{padding:5px;text-decoration:underline}
  .tab{padding:15px}
  .resp{
    display:flex;
    flex-flow: row wrap;
    justify-content:space-around;
    flex:8;
    align-items:center;
    background-color:#fbfbfb;
    padding:10px;
  }
  .resp > .tab{
    min-width:100%;
    text-align: center;
  }
  .resp2{
    display:flex;
    align-items:right;
    background-color:#fbfbfb;
    margin-right:15px;
  }
  .tab.go{
  /*background: rgba(204,11,66,1);*/
  background-color: inherit;
  color: #22407a;;
  font-weight:550;
}
.tab.go:hover, .tab.go > a:hover{
  color:inherit;
}
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue